export default __webpack_public_path__ + "static/media/foto_03.31f65a71.jpg";